// src/modules/app-views/_apps/appmulti/receivables/pages/Init/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useEffect } from 'react';
import { Table } from 'antd';
import { useListContext } from 'components/core/ListProvider';
import useZustand from 'hooks/useZustand';
import appService from 'services/appService';
import {
  customerColumn,
  billingTypeColumn,
  statusColumn,
  dueDateColumn,
  valueColumn,
} from './components/tableColumns';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const ReceivablesInit = () => {
  const {
    data,
    loading,
    tableKey,
    pagination,
    handleTableChanges,
    rowSelection,
    buildTableColumns,
    availableTableColumns,
    buildNumberLineColumn,
    buildDocumentCodeColumn,
    buildUpdatedAtColumn,
    buildDocumentInfoIconsColumn,
    buildActionsButtonColumn,
    buildColumnProps,
    query,
    tableComponents,
    hiddenColumns,
    isEditingTable,
    TableFeatures,
  } = useListContext();

  const storedListSettings = useZustand('module', 'listSettings');
  const storedLanguage = useZustand('theme', 'language');

  const sortKey = JSON.stringify(query?.sort || []);
  const searchKey = JSON.stringify(query?.search || {});
  const filterKey = JSON.stringify(query?.filter || {});

  const isMobile = appService.isMobile();

  useEffect(() => {
    buildTableColumns?.([
      buildNumberLineColumn(),
      buildDocumentCodeColumn(),
      customerColumn(buildColumnProps),
      billingTypeColumn(buildColumnProps),
      statusColumn(buildColumnProps),
      dueDateColumn(buildColumnProps),
      valueColumn(buildColumnProps),
      buildUpdatedAtColumn(),
      buildDocumentInfoIconsColumn(),
      buildActionsButtonColumn({
        view: true,
        fitInDropDownMenu: ['archive', 'remove'],
      }),
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    storedListSettings?.showNumberOfLine,
    sortKey,
    searchKey,
    filterKey,
    storedLanguage,
    hiddenColumns,
    isEditingTable,
    query?.drawer?.folder,
  ]);

  return (
    <>
      <TableFeatures />
      <Table
        key={tableKey}
        scroll={{ x: 'max-content' }}
        bordered
        rowKey="_id"
        size={isMobile ? 'small' : 'large'}
        columns={availableTableColumns}
        dataSource={data || []}
        pagination={pagination}
        className="with-checkbox"
        loading={loading}
        onChange={handleTableChanges}
        rowSelection={rowSelection}
        components={tableComponents}
      />
    </>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default ReceivablesInit;
